export const WATER_QUALITY_PARAMETERS_TABLE_COLUMNS = [
  {
    title: "Parameter",
    field: "parameter_name",
    cellStyle: {
      width: 300,
      minWidth: 300,
    },
  },
  {
    title: "Abbrev",
    field: "parameter_abbrev",
    cellStyle: {
      width: 150,
      minWidth: 150,
    },
  },
  {
    title: "Units",
    field: "unit_abbrev",
    cellStyle: {
      width: 150,
      minWidth: 150,
    },
  },
  {
    title: "Primary",
    field: "dataentry_primary",
    type: "boolean",
    cellStyle: {
      width: 120,
      minWidth: 120,
    },
  },
  {
    title: "Sort",
    field: "display_order",
    type: "numeric",
    cellStyle: {
      width: 100,
      minWidth: 100,
    },
  },
  {
    title: "Ignore",
    field: "ignore",
    type: "boolean",
    filtering: false,
    cellStyle: {
      width: 100,
      minWidth: 100,
    },
  },
  {
    title: "Notes",
    field: "parameter_notes",
    cellStyle: {
      width: 400,
      minWidth: 400,
    },
  },
];

export const DEFAULT_WATER_QUALITY_PARAMETERS_INFO_STATE = {
  aqsci_parameter_ndx: null,
  parameter_name: null,
  parameter_abbrev: null,
  aqsci_unit_ndx: null,
  notes: null,
  dataentry_primary: false,
  display_order: null,
  ignore: false,
};
